import type { ConfigPlanner } from '@miolos/core';

/**
 * Bônus do administrador: a biblioteca de prompts de IA e o caderno impresso
 * correspondente não existem para quem não recebeu a liberação.
 *
 * As telas do site aplicam esta função antes de montar o documento, então o
 * caderno de prompts nunca aparece na pré-visualização nem na impressão de quem
 * não tem o bônus — mesmo em miolos salvos quando o acesso ainda valia.
 *
 * A configuração guardada não é alterada: quando o bônus volta, o caderno
 * reaparece no miolo.
 */
export function semCadernosDeBonus(config: ConfigPlanner, permitido: boolean): ConfigPlanner {
  if (permitido) return config;

  const cadernos = config.cadernos ?? [];
  if (!cadernos.some((caderno) => caderno.tipo === 'PROMPTS')) return config;

  return { ...config, cadernos: cadernos.filter((caderno) => caderno.tipo !== 'PROMPTS') };
}

export const AVISO_BONUS_REVOGADO =
  'O caderno “Biblioteca de prompts de IA” está fora deste miolo porque o bônus da biblioteca de ' +
  'prompts não está liberado na sua conta. Assim que o administrador liberar de novo, ele volta a ' +
  'aparecer — nada foi apagado.';
